export const isValidRegex = (regex) => {
  /**
    Funzione che verifica se la regex è valida
  */

  try{
    new RegExp(regex)
  }catch (e) {
    return false
  }

  return !regex.endsWith("|");


}

export const buildRuleStructure = (rule, tagIT, tagEN, containsRegex, notContainsRegex='~') => {
  /**
   * Creates a rule object, based on an existing rule.
   * This function should be used for rule update functionalities.
   * @type {{report_id: *, index, rule: {conditions: [{next: string, field: string, operator: string, operand},{field: string, operator: string, operand: string}], value}, id, priority, type: string}}
   */
  const newRule = {
    id: rule.id,
    report_id: rule.report_id,
    priority: rule.priority,
    index: rule.index,
    type: 'manual',
    tag_it: tagIT,
    pos_regex: containsRegex,
    neg_regex: notContainsRegex,
    dependencies: [],
  }

  if (tagEN) {
    newRule.tag_en = tagEN
  }

  return newRule
}

export function checkSeoRule(rule, contieneError, nonContieneError) {
  /**
   * Requisiti minimi che una regola deve soddisfare per avviare comunicazione con backend
   * @type {boolean}
   */
  let check = true
  check = check && typeof rule.priority === 'number'
  check = check && rule.type === 'manual'
  check = check && ((rule.tag_it !== '') || (rule.tag_en !== ''))
  check = check && rule.pos_regex !== ''
  check = check && (rule.tag_it && !rule.tag_it.toString().includes(','))
  check = check && contieneError === false
  check = check && nonContieneError === false
  return check
}

export function unifyRules(customDim, savedDim) {
  /**
   * Pongo quelle non salvate dopo, per dargli priorità (rimanendo coeranti con backend reports.seo.seo_base)
   */
  if (customDim.linked) return [...savedDim.rules, ...customDim.rules]
  return customDim.rules
}
